import {
  API_BASE_URL,
  RESURS_DECISION_STATUSES,
  DELIVERY_TYPES,
  ENVIRONMENT,
  IMAGE_BASE_URL,
  INDIVIDUALIZED_TERMS_TYPES,
  LOCALES,
  ORDER_STATUSES,
  REGEX,
  ROUTES,
  SERVICE_TYPES,
  SIGNATURE_STATUSES,
  SIGNING_TYPES,
  STEPS,
  STORE,
} from '@/constants';

export const constants = {
  computed: {
    API_BASE_URL() {
      return API_BASE_URL;
    },
    IMAGE_BASE_URL() {
      return IMAGE_BASE_URL;
    },
    ROUTES() {
      return ROUTES;
    },
    SERVICE_TYPES() {
      return SERVICE_TYPES;
    },
    STEPS() {
      return STEPS;
    },
    REGEX() {
      return REGEX;
    },
    DELIVERY_TYPES() {
      return DELIVERY_TYPES;
    },
    SIGNATURE_STATUSES() {
      return SIGNATURE_STATUSES;
    },
    SIGNING_TYPES() {
      return SIGNING_TYPES;
    },
    ORDER_STATUSES() {
      return ORDER_STATUSES;
    },
    STORE() {
      return STORE;
    },
    LOCALES() {
      return LOCALES;
    },
    IS_MAINTENANCE() {
      return window.config.vue.vueAppMaintenance === 'true';
    },
    INDIVIDUALIZED_TERMS_TYPES() {
      return INDIVIDUALIZED_TERMS_TYPES;
    },
    RESURS_DECISION_STATUSES() {
      return RESURS_DECISION_STATUSES;
    },
    ENVIRONMENT() {
      return ENVIRONMENT;
    },
  },
};

export const createOptions = {
  methods: {
    createOptions(options = {}, labelPrefix) {
      return Object.keys(options).map((optionValue) => ({
        value: optionValue,
        label: labelPrefix
          ? `${this.$t(`${labelPrefix}.${options[optionValue].toUpperCase()}`)}`
          : this.$t(options[optionValue].toUpperCase()),
      }));
    },
  },
};
